<div #outsideModalCor class="modal">
  <div #modalBodyCor class="modal-content">
    <div mat-dialog-title class="modal-header">
      <h2>Recherche de destinataires</h2>
    </div>
    <mat-dialog-content>
      <div class="sticky-tabs">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="onTabChanged($event)">
          <mat-tab label="Correspondants du patient"></mat-tab>
          <mat-tab label="Annuaire Santé en ligne"></mat-tab>
          <mat-tab *ngIf="isApicryptAccount" label="Annuaire Apicrypt en ligne"></mat-tab>
        </mat-tab-group>
      </div>
      <div class="tab-content">
        <!-- Annuaire Apicrypt (LDAP)-->
        <div class="annuaire-container" *ngIf="selectedTabIndex === 2 ">
          <frg-cards class="annuaire-card" title="Annuaire Apicrypt (LDAP)">
            <div class="card">
              <div class="card-body-correspondant">
                <div class="text-infos">* Recherche uniquement les correspondants ayant une adresse Apicrypt</div>
                <form (ngSubmit)="doSearchRecipientsApi()" *ngIf="formGroup">
                    <frg-form-input label="Nom d'exercice" id="exerciceName" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('exerciceName')">
                    </frg-form-input>
                    <frg-form-input label="Prénom usuel" id="firstName" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('firstName')">
                    </frg-form-input>
                    <frg-form-input label="Profession" id="professionSpeciality" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('professionSpeciality')">
                    </frg-form-input>
                    <div class="inline-city-zipCode">
                      <frg-form-input label="Code postal" id="zip" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('zip')"></frg-form-input>
                    <frg-form-input label="Ville" id="city" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('city')"></frg-form-input>
                    </div>
                </form>
              </div>
              <div class="button-wrapper" *ngIf="formGroup">
                <frg-button class="annuaire-search-button" (activated)="doSearchRecipientsApi()"
                  [disabled]="isSearching || !formGroup.valid">Rechercher</frg-button>
                   <button mat-button type="button" title="vider le formulaire" *ngIf="isformGroupDirty" class="reset-button"
                  (click)="resetSearchForm()">
                  <mat-icon>refresh</mat-icon></button>
              </div>
               <div class="link-web-site" (click)="redirectToSiteAnnuaireApi()">
                Site web de l'annuaire Apicrypt
              </div>
            </div>
          </frg-cards>
          <frg-cards class="infos-card" [border]="false" [title]="correspondantsFiltred ? 'Liste des résultats de la recherche : ' + (resultApi.total > resultApi.result.length
             ? 'plus de ' + resultApi.result.length : resultApi.result.length) +' résultat(s) trouvé(s)': ''">
            <ng-container *ngIf="isSearching; else resultBlock">
              <div class="custom-spinner-wrapper">
                <div class="custom-spinner"></div>
              </div>
            </ng-container>
            <ng-template #resultBlock>
              <div class="card-body-infos">
                <div class="correspondants-list" *ngIf="correspondantsFiltred">
                  <div class="correspondants" *ngFor="let correspondant of correspondantsFiltred">
                    <div class="correspondant-name">
                      <p>{{correspondant.nom ? correspondant.nom : ''}} {{correspondant.prenom ?
                        correspondant.prenom : ''}}</p>
                    </div>
                    <div class="correspondant-name">
                      {{correspondant.codePostal ? correspondant.codePostal : ''}} {{correspondant.ville ?
                        correspondant.ville :
                        ''}}
                    </div>
                    <div class="correspondant-name">
                      {{correspondant.professionName ? correspondant.professionName : ''}}
                    </div>
                     <button title="Plus d'informations" mat-icon-button
                      (click)="openDetails(correspondant)"><mat-icon style="color: var(--primary);">info</mat-icon></button>
                    <button mat-icon-button *ngIf="correspondant.adresseApiCrypt" (click)="selectCorrespondant(correspondant,'adresseApiCrypt', correspondant.adresseApiCrypt)" style="border: none; box-shadow: none;">
                      <mat-icon class="icon-transform" [title]="correspondant.adresseApiCrypt" style="color: #2c54db; background-color: white;" *ngIf="correspondant.adresseApiCrypt">add_circle</mat-icon>
                    </button>
                    <button mat-icon-button disabled style="box-shadow: none; border: none;" *ngIf="correspondant.adresseApiCrypt === undefined || correspondant.adresseApiCrypt === '' ">
                     <mat-icon class="icon-no-address" title="Aucune adresse Apicrypt renseignée"
                        >highlight_off</mat-icon>
                    </button>
                  </div>
                  <div class="no-info" *ngIf="correspondantsFiltred.length === 0">
                    <p>Votre recherche n'a retourné aucun résultat</p>
                  </div>
                </div>
              </div>
            </ng-template>
          </frg-cards>
        </div>
        <!-- Correspondants du patient -->
        <div class="annuaire-container" *ngIf="selectedTabIndex === 0 ">
            <div class="card-body-correspondant-patient">
              <div class="correspondant-container">
                <frg-cards class="correspondant-patient-table-container"
                [title]="getTableTitle('patient')">
                <!-- <frg-cards class="correspondant-patient-table-container"
                [title]="'Correspondants du patient'"
                [subtitle]="'Avec une adresse Apicrypt ou MSSante'" *ngIf="test"> -->
                <table mat-table [dataSource]="dataSource" #table2 class="table">
                  <ng-container matColumnDef="correspondantName">
                    <td mat-cell class="correspondant-patient-name" *matCellDef="let correspondant">
                      {{ correspondant.nom}} {{correspondant.prenom}}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="adresseMail">
                    <td mat-cell style="padding: 1rem;" *matCellDef="let correspondant" >
                      <div class="correspondant-cell">
                        <span class="correspondant-line" *ngIf="correspondant.emails.length > 0">
                          <ng-container *ngIf="correspondant.emails.length === 1; else multipleEmails">
                            <span [title]="correspondant.emails[0].value">
                              {{ correspondant.emails[0].value }}
                            </span>
                            <mat-icon class="icon-transform"
                                      style="color: #2c54db; cursor: pointer;"
                                      (click)="selectCorrespondant(correspondant, correspondant.emails[0].type, correspondant.emails[0].value)">
                              add_circle
                            </mat-icon>
                          </ng-container>

                          <ng-template #multipleEmails>
                            <mat-select class="mail-select" placeholder="Voir toutes les adresses mail"
                                        (selectionChange)="selectCorrespondant(correspondant, $event.value.type, $event.value.value)">
                              <mat-option *ngFor="let mail of correspondant.emails" [value]="mail" [title]="mail.value">
                                <span *ngIf="mail.favorite">★</span>
                                  {{ mail.value }}
                              </mat-option>
                            </mat-select>
                          </ng-template>

                        </span>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
               <div class="no-correspondant" *ngIf="dataSource && dataSource.data.length ===0">Aucun correspondant avec une adresse Apicrypt ou MSsanté n'a été trouvé.</div>
              </frg-cards>
                <frg-cards class="correspondant-cabinet-table-container" [title]="getTableTitle('cabinet')">
                  <!-- <frg-cards class="correspondant-cabinet-table-container"
                [title]="'Correspondants du cabinet'"
                [subtitle]="' Avec une adresse Apicrypt ou MSSanté'"> -->
                  <frg-search-input #searchInput (search)="filterCorrespondants($event)"></frg-search-input>
                  <table mat-table [dataSource]="dataSourceCabinet" #table2 class="table">
                  <ng-container matColumnDef="correspondantName">
                    <td mat-cell class="correspondant-name" *matCellDef="let correspondant">
                      {{ correspondant.nom}} {{correspondant.prenom}}
                    </td>
                  </ng-container>
                   <ng-container matColumnDef="adresseMail">
                    <td mat-cell style="padding: 1rem;" *matCellDef="let correspondant" >
                      <div class="correspondant-cell">
                        <span class="correspondant-line" *ngIf="correspondant.emails.length > 0">
                          <ng-container *ngIf="correspondant.emails.length === 1; else multipleEmails">
                            <span [title]="correspondant.emails[0].value">
                              {{ correspondant.emails[0].value }}
                            </span>
                            <mat-icon class="icon-transform"
                                      style="color: #2c54db; cursor: pointer;"
                                      (click)="selectCorrespondant(correspondant, correspondant.emails[0].type, correspondant.emails[0].value)">
                              add_circle
                            </mat-icon>
                          </ng-container>

                          <ng-template #multipleEmails>
                            <mat-select class="mail-select" placeholder="Voir toutes les adresses mail"
                                        (selectionChange)="selectCorrespondant(correspondant, $event.value.type, $event.value.value)">
                              <mat-option *ngFor="let mail of correspondant.emails" [value]="mail" [title]="mail.value">
                                <span *ngIf="mail.favorite">★</span>
                                {{ mail.value }}
                              </mat-option>
                            </mat-select>
                          </ng-template>

                        </span>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsCabinet"></tr>
                </table>
               <div class="no-correspondant" *ngIf="searchDone && dataSourceCabinet.data.length ===0">Aucun correspondant avec une adresse Apicrypt ou MSSanté n'a été trouvé.</div>
                </frg-cards>
              </div>
          </div>
        </div>
        <!-- Annuaire Santé (LDAP) -->
        <div class="annuaire-container" *ngIf="selectedTabIndex === 1 ">
          <frg-cards class="annuaire-card" title="Annuaire Santé (LDAP)">
            <div class="card">
              <div class="card-body-correspondant">
                <div class="text-infos">* Recherche uniquement les correspondants ayant une adresse MSsanté</div>
                <form (ngSubmit)="doSearchRecipients()" *ngIf="formGroup">
                    <frg-form-input label="Nom d'exercice" id="exerciceName" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('exerciceName')">
                    </frg-form-input>
                    <frg-form-input label="Prénom d'exercice" id="firstName" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('firstName')">
                    </frg-form-input>
                    <frg-form-input label="Profession" id="profession" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('profession')">
                    </frg-form-input>
                    <frg-form-input label="Spécialité" id="speciality" type="ngSelect" [selectValue]="specialites" [formGroup]="formGroup"
                      [control]="formGroup.get('speciality')">
                    </frg-form-input>
                    <frg-form-input label="RPPS" id="rpps" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('rpps')">
                    </frg-form-input>
                    <frg-form-input label="Structure / Adresse" id="structureOrAddress" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('structureOrAddress')">
                    </frg-form-input>
                    <frg-form-input label="Adresse e-mail MSS" id="email" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('email')">
                    </frg-form-input>
                    <div class="inline-city-zipCode">
                      <frg-form-input label="Code postal" id="zip" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('zip')"></frg-form-input>
                    <frg-form-input label="Ville" id="city" type="text" [formGroup]="formGroup"
                      [control]="formGroup.get('city')"></frg-form-input>
                    </div>
                </form>
              </div>
              <div class="button-wrapper" *ngIf="formGroup">
                <frg-button class="annuaire-search-button" (activated)="doSearchRecipients()"
                  [disabled]="isSearching || !formGroup.valid">Rechercher</frg-button>
                   <button mat-button type="button" title="vider le formulaire" *ngIf="isformGroupDirty" class="reset-button"
                  (click)="resetSearchForm()">
                  <mat-icon>refresh</mat-icon></button>
              </div>
              <div class="link-web-site" (click)="redirectToSiteAnnuaire()">
                Site web de l'annuaire de santé
              </div>
            </div>
          </frg-cards>
          <frg-cards class="infos-card" [border]="false" [title]="correspondantsFiltred ? 'Liste des résultats de la recherche : ' + (result.total > result.result.length
              ? 'plus de ' + result.result.length : result.result.length) +' résultat(s) trouvé(s)': ''">
            <ng-container *ngIf="isSearching; else resultBlock">
              <div class="custom-spinner-wrapper">
                <div class="custom-spinner"></div>
              </div>
            </ng-container>
            <ng-template #resultBlock>
              <div class="card-body-infos">
                <div class="correspondants-list" *ngIf="correspondantsFiltred">
                  <div class="correspondants" *ngFor="let correspondant of correspondantsFiltred">
                    <div class="correspondant-name">
                      <p>{{correspondant.nom ? correspondant.nom : ''}} {{correspondant.prenom ? correspondant.prenom : ''}}</p>
                    </div>
                    <div class="correspondant-name">
                      <p *ngIf="correspondant.adresse1">{{correspondant.adresse1}}</p>
                      {{correspondant.codePostal ? correspondant.codePostal : ''}} {{correspondant.ville ? correspondant.ville : ''}}
                    </div>
                    <div class="correspondant-name">
                      <p *ngIf="correspondant.professionName || correspondant.specialiteName">
                        {{correspondant.professionName ? correspondant.professionName : ''}} 
                        <span *ngIf="correspondant.professionName && correspondant.specialiteName">-</span> 
                        {{correspondant.specialiteName ? correspondant.specialiteName : ''}}
                      </p>
                      <p *ngIf="correspondant.rpps">RPPS : {{correspondant.rpps}}</p>
                    </div>
                     <button title="Plus d'informations" mat-icon-button
                      (click)="openDetails(correspondant)"><mat-icon style="color: var(--primary);">info</mat-icon></button>
                    <button mat-icon-button *ngIf="correspondant.email2" (click)="selectCorrespondant(correspondant,'email2', correspondant.email2)" style="border: none; box-shadow: none;">
                      <mat-icon class="icon-transform" [title]="correspondant.email2" style="color: #2c54db; background-color: white;" *ngIf="correspondant.email2">add_circle</mat-icon>
                    </button>
                    <button mat-icon-button disabled style="box-shadow: none; border: none;" *ngIf="correspondant.email2 === undefined || correspondant.email2 === '' ">
                     <mat-icon title="Aucune adresse MSS renseignée" class="icon-no-address"
                        >highlight_off</mat-icon>
                    </button>
                  </div>
                  <div class="no-info" *ngIf="correspondantsFiltred.length === 0">
                    <p>Votre recherche n'a retourné aucun résultat</p>
                  </div>
                </div>
              </div>
            </ng-template>
          </frg-cards>
        </div>
      </div>
    </mat-dialog-content>
    <div *ngIf="finalSelectedCorrespondants.length>0" class="selected-correspondants">
      <mat-label class="selected-correspondants-title">Correspondants sélectionnés: </mat-label>
      <mat-chip-list #chipList aria-label="Liste des correspondants">
        <mat-chip [title]="getChipTitle(correspondant)" class="custom-chip" *ngFor="let correspondant of finalSelectedCorrespondants; let i = index"
          [selectable]="false" [removable]="true" (removed)="removeCorrespondant(i)">
          {{ correspondant.nom }} {{correspondant.prenom}}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-list>
    </div>
    <div class="footer">
      <div>
        <frg-button type="button" (activated)=" closeAddEditModal()" [backgroundColor]="'var(--darkest-primary)'" >Fermer</frg-button>
      </div>
      <div>
        <frg-button type="button" (activated)=" validateCorrespondants()" [backgroundColor]="'var(--darkest-primary)'" >Valider les
          correspondants</frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>
